import { IOrganizationTableUser } from '@account_module/types/Organizations';

export const BaseCell = (item: keyof IOrganizationTableUser): JSX.Element => {
  return <div>{item}</div>;
};
